import { graphql } from 'react-relay/legacy';
import commitMutation from 'relay-commit-mutation-promise';

const mutation = graphql`
    mutation paymentDataFor3dsMutation($input: PaymentDataFor3dsMutationInput!) {
        paymentDataFor3ds(input: $input) {
            paymentMethodNonce {
                nonce
                bin
                regulationEnvironment
            }
            clientToken {
                value
                environment
            }
        }
    }
`;

export default function (environment, input) {
    return commitMutation(environment, { mutation, variables: { input } });
}
